// extracted by mini-css-extract-plugin
export var container = "_4s-1";
export var cornerButtonContainer = "_4s-5";
export var disabled = "_4s-2";
export var fileContainer = "_4s-4";
export var hiddenInput = "_4s-3";
export var widthContainer = "_4s-0";